import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { planworkConfig } from 'app/planwork.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonModalComponent } from '../core/common/common-modal/common-modal.component';

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  config: any;
  SpinnerTimeout = 500;
  ClientIP: any;
  IPAddress: any;
  apiUrl: any;
  apiUrlCampaign: any;
  private baseUrl: any;
  private otherActivityUrl: any;
  dialogRef: any;
  exceptionText = 'There are some exception error, Please contact to support team.';
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) {
    // this.http.get<any>('https://jsonip.com').subscribe(data => {
    //   const serverIp = data.ip;
    //   const privateIP = this.ClientIP;
    //   const IP = serverIp + ':' + privateIP;
    //   this.IPAddress = IP;
    // });
    this.apiUrl = planworkConfig;
    this.baseUrl = this.apiUrl.baseUrl + this.apiUrl.TaskBaseUrl + 'Task/';
    this.otherActivityUrl = this.apiUrl.baseUrl + this.apiUrl.TaskBaseUrl;


  }

  postService(saveData: any, currentUrl: any): Observable<any> {
    const currentToken = localStorage.getItem('token');
    const sbuid = localStorage.getItem('SbuId');
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      SbuId: sbuid ? sbuid : '0'
    });
    return this.http.post(this.baseUrl + currentUrl, saveData, {
      headers: httpHeaders,
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }

  OtherActivityService(saveData: any, currentUrl: any): Observable<any> {
    const currentToken = localStorage.getItem('token');
    const sbuid = localStorage.getItem('SbuId');
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      SbuId: sbuid ? sbuid : '0'
    });
    return this.http.post(this.otherActivityUrl + currentUrl, saveData, {
      headers: httpHeaders,
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }
}
